import { useSelector } from 'react-redux'
import { useState, useEffect } from "react";
import { Grid, Card, Alert, AlertTitle } from '@mui/material';
import { gridSpacing } from '../../store/constant';
import StickyHeadOneButtonTable from '../components/StickyHeadOneButtonTable';
import axios from "../../components/axios";
import { useNavigate } from 'react-router-dom';


const columns = [
  { id: 'token', label: 'Token', align: 'left'},
  { id: 'create_time', label: 'Create Time', align: 'center'},
  { id: 'data', label: 'Data', align: 'left'},
  //{ id: 'action', label: 'Delete', align: 'center', delete: true},
];

const NestlingPlusQueuePage = () => {
    const customization = useSelector((state) => state.customization);
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [showAlert, setshowAlert] = useState(false);

    useEffect(() => {
        const getRemoteAutoQueue = async () => {
            try {
                setshowAlert(false);
                const response = await axios.post("/peloton/v1/automation/freestyle-items", null, { withCredentials: true});
                if (response.data.message === "success"){
                    if (response.data.data !== null){
                        setRows(response.data.data);
                    }else{
                        setshowAlert(true);
                    }
                }
            } catch (error) {
                if (error.response.status !== null){
                    if (error.response.status === 401){
                        alert(error.response.data.message);
                        navigate("/");
                    }else{
                        console.log('error.response.status: ', error.response.status)
                        console.log('error.response.message: ', error.response.data.message)
                    }
                }else{
                    console.log(error);
                }
            }
        };
        getRemoteAutoQueue();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Grid container spacing={gridSpacing} alignItems="center" sx={{ marginTop: "40px"}}>
            <Grid item xs={12} >
                {customization.login && (<StickyHeadOneButtonTable rows={rows} columns={columns} title="Nestling+ Queue"/>)}
            { showAlert && (<Card variant="outlined" sx={{ bgcolor: "white" }}><Alert severity="warning">
                <AlertTitle>Warning</AlertTitle>
                No data in this condition.
              </Alert></Card>)}
            </Grid>
        </Grid>
    );
};

export default NestlingPlusQueuePage;
